"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const assetsAreLoaded_1 = __importDefault(require("./assetsAreLoaded"));
const attemptScratch_1 = __importDefault(require("./attemptScratch"));
const getAudioSource_1 = __importDefault(require("./definables/getAudioSource"));
const isCatStarving_1 = __importDefault(require("./isCatStarving"));
const levelIsCompleted_1 = __importDefault(require("./levelIsCompleted"));
const handleAction = () => {
    var _a, _b;
    if (state_1.default.won === false && (0, assetsAreLoaded_1.default)()) {
        if (state_1.default.isAwaitingFocus) {
            (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("focus");
            (_b = document.getElementById("screen")) === null || _b === void 0 ? void 0 : _b.classList.add("title");
            const titleMusic = (0, getAudioSource_1.default)("music/title");
            titleMusic.play(null, null);
            state_1.default.isAwaitingFocus = false;
            state_1.default.isAtTitle = true;
        }
        else if (state_1.default.isAtTitle) {
        }
        else if ((0, isCatStarving_1.default)()) {
        }
        else if ((0, levelIsCompleted_1.default)()) {
        }
        else if (state_1.default.isInBed) {
            (0, getAudioSource_1.default)("noises/meow").play(null, null);
            state_1.default.isInBed = false;
            state_1.default.levelStartedAt = state_1.default.currentTime;
        }
        else {
            (0, attemptScratch_1.default)();
        }
    }
};
exports.default = handleAction;
